<template>
    <div>
        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-3 shape-red shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-12">
                                <h2 class="display-2 text-white">Web Based Logging & Reporting
                                    <span>3Z’s FlexYard and FlexTrim control systems</span>
                                </h2>
                                <p class="lead  text-white">are designed and deployed with remote access capability. Event logs, system reports, daily reports, system health, component diagnostics, and alarm alerting are all accessed using web browsers. It doesn’t matter if you’re at the yard on the technician’s workstation or in your office at your railroad’s headquarters, if your system has a connection to your RR’s network, authorized users can access this information and these features. As long as you are on a computer with a web browser, you have access to all system reports, logs, and alerts.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        <section class="section section-lg pt-lg-0 mt--200">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid justify-content-center">
                            <div class="col-lg-6">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-check-bold" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary text-uppercase">Remote Access via Web BrowserFlexYard and FlexTrim Features and Capabilities</h6>
                                    <ul class="list">
                                        <li>Event Logs</li>
                                        <li>Incident Analysis</li>
                                        <li>Daily Reports</li>
                                        <li>Customizable and Automated Report Generator</li>
                                        <li>Real Time Alarm Monitoring</li>
                                        <li>Customizable Alert Generator</li>
                                        <li>System and Component Health Status Monitoring</li>
                                        <li>System and Component Diagnostics</li>
                                        <li>Alarm and Health Logs</li>
                                    </ul>
                                    <div>
                                        <badge type="primary" rounded>Customizable</badge>
                                        <badge type="primary" rounded>RealTime</badge>
                                        <badge type="primary" rounded>logs</badge>
                                    </div>
                                    <!-- <base-button tag="a" href="#" type="primary" class="mt-4">
                                        Learn more
                                    </base-button> -->
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section bg-secondary">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-5">
                        <div class="card bg-darkred shadow border-0">
                            <img v-lazy="'img/3z/WebHome.jpeg'" class="card-img-top">
                            <blockquote class="card-blockquote">
                                <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                     class="svg-bg">
                                    <polygon points="0,52 583,95 0,95" class="fill-darkred"></polygon>
                                    <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-darkred"></polygon>
                                </svg>
                                <h4 class="display-3 font-weight-bold text-white">Web-based Technology</h4>
                                <p class="lead text-italic text-white">3Accessibility is one of the most desirable facets in today’s transportation industry. Specifically, accessibility to data… from anywhere.
                            Technological advances over the last decade have made remote access to via communications network relatively simple. 3Z utilizes this technology to the fullest by making all pertinent information about the operations and infrastructure of a yard immediately available from anywhere.</p>
                            </blockquote>
                        </div>
                    </div>
                    <div class="col-md-7">
                        <div class="pl-md-5">
                            <icon name="ni ni-settings" class="mb-5" size="lg"  shadow rounded></icon>

                            <h2 class="display-2 text-red">Take Control: Expand Accessibility and Gain Viability</h2>
                            <p class="lead">With 3Z’s FlexYard or FlexTrim, a headquarter executive can, and should, have the ability to see exactly what the local technician or operations manager can see. All system event logs, production reports, maintenance reports, health statuses, and alarms can be accessed by any authorized person with a web browser. This means no special computer, computer application, or OS environment is required to have direct access to the pertinent information about a yard at a moment’s notice.</p>
                            <p class="lead">With this capability, technical and operational executives have the ability to customize their own reports, export their chosen data, create their own alarms, and view the system diagnostics on their own. These features allow executives to make proactive decisions regarding system maintenance, bowl usage, operational production, and logistical optimization. Also, executives that gain this ability receive the local information at the same time the local employees do. This means executives can access more data faster resulting in better decisions sooner. Ultimately, viability is gained by acquiring the ability to eliminate risk in a yard environment.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
    </div>
</template>
<script>
// import Hero from "@/views/components/3Z/Hero";
// import BasicElements from "./components/BasicElements";
// import Inputs from "./components/Inputs";
// import CustomControls from "./components/CustomControls";
// import Navigation from "./components/3Z/Navigation";
import JavascriptComponents from "@/views/components/3Z/JavascriptComponents";
import Carousel from "@/views/components/3Z/Carousel";
import Icons from "./components/Icons";
import Examples from "./components/Examples";
import DownloadSection from "./components/DownloadSection";

export default {
  name: "Index",
  components: {
    // Hero,
    // BasicElements,
    // Inputs,
    // CustomControls,
    // Navigation,
    JavascriptComponents,
    Carousel,
    Icons,
    Examples,
    DownloadSection
  }
};
</script>
<style scoped>
ul.list {
    padding-left: 1.2rem!important;
}
</style>